import { Moon, Sun } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getTheme, setTheme, type Theme } from "../../theme";

export default function ThemeToggle() {
  const { t } = useTranslation();
  const [theme, updateTheme] = useState<Theme>(getTheme);
  const dark = theme === "dark";
  const label = dark ? t("Use light mode") : t("Use dark mode");

  return (
    <button
      type="button"
      className="icon-button theme-toggle"
      title={label}
      aria-label={label}
      aria-pressed={dark}
      onClick={() => {
        const next = dark ? "light" : "dark";
        setTheme(next);
        updateTheme(next);
      }}
    >
      {dark ? <Sun size={17} /> : <Moon size={17} />}
    </button>
  );
}
